// extracted by mini-css-extract-plugin
module.exports = {"root":"LogoFooter_root___citQ","popup":"LogoFooter_popup__OXGSG","menu":"LogoFooter_menu__en2Aj","fadeIn":"LogoFooter_fadeIn__4OdXM","spin":"LogoFooter_spin__Ow5RZ"};